import { PhoneCountryCodeType } from '@bus/models';
import { BusinessProspectFormModel } from './formModel';

export const getInitialValues = (): BusinessProspectFormModel => {
  return {
    businessCustomerType: undefined,
    legalName: '',
    countryCode: PhoneCountryCodeType.Ireland,
    mobileNumber: '',
    email: '',
    storeQuoteTwelveMonths: undefined,
  };
};
